import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink, Image } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { useIntl } from 'react-intl';
import DefaultImageSVG from '@plone/volto/components/manage/Blocks/Listing/default-image.svg';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import moment from 'moment';
import { getFilmDatesRecurrence } from '@package/helpers';

const FilmsTemplate = ({ items, linkMore, isEditMode }) => {
  const intl = useIntl();
  moment.locale(intl.locale);

  let link = null;
  let href = linkMore?.href || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkMore?.title || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkMore?.title || href}</a>;
  }

  return (
    <>
      <div className="items films-template">
        {items.map((item) => (
          <div className="listing-item" key={item['@id']}>
            <ConditionalLink
              className="film-item"
              to={flattenToAppURL(item['@id'])}
              condition={!isEditMode}
            >
              {!item.image_field && <Image src={DefaultImageSVG} alt="" />}
              {item.image_field && (
                <Image
                  src={flattenToAppURL(item.getURL + '/@@images/image/preview')}
                  alt={item.title}
                />
              )}
              <div className="infoContainer">
                <div className="film-infos-container">
                  <div className="infos">
                    {item.start && (
                      <div className="info-slot">
                        <span className="mr-1 font-weight-600">
                          Data:&nbsp;
                        </span>
                        {!item.recurrence ? (
                          <span>{moment(item.start).format('DD/MM/YYYY')}</span>
                        ) : (
                          getFilmDatesRecurrence(item)
                        )}
                      </div>
                    )}
                    {item.start && (
                      <div className="info-slot">
                        <span className="mr-1 font-weight-600">
                          Orario:&nbsp;
                        </span>
                        {!item.recurrence ? (
                          <span>{moment(item.start).format('HH:mm')}</span>
                        ) : (
                          'vedi dettagli scheda'
                        )}
                      </div>
                    )}

                    {item.rassegna && (
                      <div className="info-slot">
                        <span className="mr-1 font-weight-600">
                          Rassegna:&nbsp;
                        </span>
                        <span>{item.rassegna.join('; ')}</span>
                      </div>
                    )}
                    {item.regia && (
                      <div className="info-slot">
                        <span className="mr-1 font-weight-600">
                          Regia:&nbsp;
                        </span>
                        <span>{item.regia}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="listing-body">
                  <h3>{item.title ? item.title : item.id}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            </ConditionalLink>
          </div>
        ))}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

FilmsTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default FilmsTemplate;
